export const AllProgressCheckPdfScreenPath = "/progress-check-pdfs";
export const CreateProgressCheckPdfScreenPath = "/progress-check-pdfs/new";
export const EditProgressCheckPdfScreenPath =
  "/progress-check-pdfs/:level/:userGroupId";
